export enum ArchiveProjectStatus {
    WITHDRAWN = 'WITHDRAWN',
    OVERDUE_APPROVED = 'OVERDUE_APPROVED',
    OVERDUE_PENDING = 'OVERDUE_PENDING',
    OVERDUE_DECLINED = 'OVERDUE_DECLINED',
    OVERDUE_REGISTERED = 'OVERDUE_REGISTERED',
    OVERDUE_HANDED_IN = 'OVERDUE_HANDED_IN',
    COMPLETED = 'COMPLETED',
    UNKNOWN = 'UNKNOWN',
    USER_DELETED = 'USER_DELETED',
    FAILED = 'FAILED',
}

export const archiveProjectStatusToStringMapper = (
    status: ArchiveProjectStatus,
    localization: {
        completed: string;
        overdueRegistered: string;
        overdueHandedIn: string;
        overdueApproved: string;
        overdueDeclined: string;
        overduePending: string;
        withdrawn: string;
        unknown: string;
        userDeleted: string;
        failed: string;
    }
) => {
    switch (status) {
        case ArchiveProjectStatus.COMPLETED:
            return localization.completed;
        case ArchiveProjectStatus.OVERDUE_HANDED_IN:
            return localization.overdueHandedIn;
        case ArchiveProjectStatus.OVERDUE_REGISTERED:
            return localization.overdueRegistered;
        case ArchiveProjectStatus.WITHDRAWN:
            return localization.withdrawn;
        case ArchiveProjectStatus.OVERDUE_APPROVED:
            return localization.overdueApproved;
        case ArchiveProjectStatus.OVERDUE_DECLINED:
            return localization.overdueDeclined;
        case ArchiveProjectStatus.OVERDUE_PENDING:
            return localization.overduePending;
        case ArchiveProjectStatus.UNKNOWN:
            return localization.unknown;
        case ArchiveProjectStatus.USER_DELETED:
            return localization.userDeleted;
        case ArchiveProjectStatus.FAILED:
            return localization.failed;
        default:
            return status;
    }
};
